module.exports = __webpack_public_path__ + "static/media/logo_GF.1cba4573.svg";